<template>
<section class='mb-2'>
  <b-input v-model="search" @input="searchProduct" @keydown.enter="handleEnter" :placeholder="placeholder" :required="required" />
    <div v-for="result,ix in results" :key="ix" class='ml-4 my-1' style="border-bottom: 1px solid gainsboro" @click="selectProduct(result)">
      <b-btn block variant=link style="text-align:left; color:black;" @click.prevent>
        <strong>{{result.num}}</strong>:
        {{result.description}}
      </b-btn>
    </div>
</section>
</template>

<script>
import fishbowlService from '../../services/fishbowl'

export default {
  props: {
    default: { required: false, default: null },
    placeholder: { required: false, default: 'SKU Here' },
    required: { required: false, default: false },
  },
  data() {
    return {
      search: '',
      results: [],
      timer: undefined
    };
  },
  mounted() {
    this.search = this.default
    this.searchProduct(this.search, true, false)
  },
  methods: {
    searchProduct(input, immediate=false, showResults=true) {
      if (input.length < 4) return
      if (this.timer) {
        clearTimeout(this.timer)
      }

      fishbowlService.searchProduct(input).then(response => {
        if (this.search === input) {
          this.results = response
          let filter = response.filter(x => x.num === this.search)
          if (filter.length === 1) {
            this.timer = setTimeout(() => {
              this.selectProduct(filter[0], !showResults)
            }, immediate ? 0 : 1000)
          }
        }
      })
    },
    handleEnter() {
      let filter = this.results.filter(x => x.num === this.search)
      if (filter.length === 1) {
        this.selectProduct(filter[0])
        this.search = ''
        this.$emit('enterPressed')
      }
    },
    selectProduct(result, immediate=false) {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.search = result.num;
      this.$emit('select', result);
      this.timer = setTimeout(() => {
        if (this.search === result.num) {
          this.results = []
        }
      }, immediate ? 0 : 1500)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utility/ProductSearchInput.vue